import { render, staticRenderFns } from "./CardServiceDetailList.vue?vue&type=template&id=aa5b0c18"
import script from "./CardServiceDetailList.vue?vue&type=script&lang=js"
export * from "./CardServiceDetailList.vue?vue&type=script&lang=js"
import style0 from "./CardServiceDetailList.vue?vue&type=style&index=0&id=aa5b0c18&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa5b0c18')) {
      api.createRecord('aa5b0c18', component.options)
    } else {
      api.reload('aa5b0c18', component.options)
    }
    module.hot.accept("./CardServiceDetailList.vue?vue&type=template&id=aa5b0c18", function () {
      api.rerender('aa5b0c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardServiceDetailList.vue"
export default component.exports